import * as types from './mutations_types'
import { removeById } from 'utils/helpers/arrays'
import { find, isNil } from 'lodash'

export default {
    [types.SET] (state, items) {
        state.all = items
    },
    [types.CLEAR] (state) {
        state.all = []
    },
    [types.SAVE] (state, item) {
        if (!isNil(find(state.all, { id: item.id })))
            removeById(state.all, item.id)

        state.all.push(item)
    },
    [types.DESTROY] (state, id) {
        removeById(state.all, id)
    }
}



// WEBPACK FOOTER //
// ./src/modules/deals/components/show/emails/store/mutations.js